import React from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AppProvider } from "@/context/AppContext";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import DealCalculation from "@/pages/DealCalculation";
import Contracts from "@/pages/Contracts";
import BackToBack from "@/pages/BackToBack";
import Vessels from "@/pages/Vessels";
import Positions from "@/pages/Positions";
import TradeFinance from "@/pages/TradeFinance";
import Invoices from "@/pages/Invoices";
import FundFlow from "@/pages/FundFlow";
import Counterparties from "@/pages/Counterparties";
import Accounting from "@/pages/Accounting";
import Masters from "@/pages/Masters";

const P = (title, Comp) => (
  <Layout title={title}>
    <Comp />
  </Layout>
);

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={P("Executive Dashboard", Dashboard)} />
          <Route path="/deals" element={P("Deal Calculation", DealCalculation)} />
          <Route path="/contracts" element={P("Contract Management", Contracts)} />
          <Route path="/linking" element={P("Back-to-Back Linking", BackToBack)} />
          <Route path="/vessels" element={P("Vessels & Logistics", Vessels)} />
          <Route path="/positions" element={P("Position & Risk Management", Positions)} />
          <Route path="/finance" element={P("Trade Finance", TradeFinance)} />
          <Route path="/invoices" element={P("Invoice Workflow", Invoices)} />
          <Route path="/fund-flow" element={P("Fund Flow & Liquidity", FundFlow)} />
          <Route path="/counterparties" element={P("Counterparty & Credit Risk", Counterparties)} />
          <Route path="/accounting" element={P("Accounting & General Ledger", Accounting)} />
          <Route path="/masters" element={P("Master Data", Masters)} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AppProvider>
  );
}

export default App;
